import { getTransactionName } from "@constants/transaction"
import { 
    BankTopUp,
    Crypto,
    Bank,
    Transfer,
    ArrowUp,
    ArrowDown,
    TagContainer,
    TagText,
    PaymentLink
} from "./TransactionTypeTag.styles"
import { useTranslation } from 'react-i18next'

type Props = {
    code?: number
}

const Icon = ({ code = 101 }: Props) => {
    switch (code) {
        case 101:
            return <BankTopUp />
        case 301:
            return <ArrowDown />
        case 302:
            return <ArrowUp />
        case 201:
        case 203:
            return <Bank />
        case 601:
        case 602:
            return <Transfer />
        case 102:
        case 202:
        case 701:
        case 801:
            return <Crypto />
        case 901:
            return <ArrowDown />
        default:
            return <PaymentLink />
    }
}

const TransactionTypeTag = ({ code }: Props) => {
    const { t } = useTranslation();
    
    // Get the transaction name safely
    const transactionName = typeof code === 'number' 
        ? getTransactionName(code)
        : t('components.transactionTypeTag.fallbackText');
    
    return (
        <TagContainer>
            <TagText>
                {transactionName || t('components.transactionTypeTag.fallbackText')}
            </TagText>
            <Icon code={code} />
        </TagContainer>
    )
}

export default TransactionTypeTag